import { render, staticRenderFns } from "./bursary_categories.vue?vue&type=template&id=a85fa5ac&"
import script from "./bursary_categories.vue?vue&type=script&lang=js&"
export * from "./bursary_categories.vue?vue&type=script&lang=js&"
import style0 from "./bursary_categories.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports